import { selfAxios } from "../../../../../axios/selfAxios.js";
async function designBaseLog(params) {
  const { data } = await selfAxios.post(`/designapi/design/base/log`, params);
  return data;
}
export { designBaseLog };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/base/log/post.js